@if (paymentLanding.isPending) {
  <div class="content">
    <div class="tvh-spinner">
      <mat-spinner></mat-spinner>
    </div>
    <div class="spinner-info-text">
      {{ 'LANDING.CHECKING_PAYMENT_STATUS' | translate }}
    </div>
  </div>
} @else if (paymentLanding.hasRetrievalFailed) {
  <div class="content">
    <h1 class="mat-warn">{{ 'LANDING.UH_OH' | translate }}</h1>
    <h2 class="mat-warn">{{ 'LANDING.PAYMENT_RETRIEVAL_FAILED' | translate }}</h2>
  </div>
}
<router-outlet></router-outlet>
